import { PrefixIcon } from '@/constants/enum';

export const emoticons = {
  red_car: {
    keywords: ['red', 'transportation', 'vehicle'],
    char: '🚗',
    fitzpatrick_scale: false,
    category: 'Most used',
  },
  taxi: {
    keywords: ['uber', 'vehicle', 'cars', 'transportation'],
    char: '🚕',
    fitzpatrick_scale: false,
    category: 'Most used',
  },
  blue_car: {
    keywords: ['transportation', 'vehicle'],
    char: '🚙',
    fitzpatrick_scale: false,
    category: 'Most used',
  },
  bus: {
    keywords: ['car', 'vehicle', 'transportation'],
    char: '🚌',
    fitzpatrick_scale: false,
    category: 'Most used',
  },
  trolleybus: {
    keywords: ['bart', 'transportation', 'vehicle'],
    char: '🚎',
    fitzpatrick_scale: false,
    category: 'Most used',
  },
  racing_car: {
    keywords: ['sports', 'race', 'fast', 'formula', 'f1'],
    char: '🏎',
    fitzpatrick_scale: false,
    category: 'Most used',
  },
  police_car: {
    keywords: ['vehicle', 'cars', 'transportation', 'law', 'legal', 'enforcement'],
    char: '🚓',
    fitzpatrick_scale: false,
    category: 'Most used',
  },
  ambulance: {
    keywords: ['health', '911', 'hospital'],
    char: '🚑',
    fitzpatrick_scale: false,
    category: 'Most used',
  },
  fire_engine: {
    keywords: ['transportation', 'cars', 'vehicle'],
    char: '🚒',
    fitzpatrick_scale: false,
    category: 'Most used',
  },
  minibus: {
    keywords: ['vehicle', 'car', 'transportation'],
    char: '🚐',
    fitzpatrick_scale: false,
    category: 'Most used',
  },
  truck: { keywords: ['cars', 'transportation'], char: '🚚', fitzpatrick_scale: false, category: 'Most used' },
  articulated_lorry: {
    keywords: ['vehicle', 'cars', 'transportation', 'express'],
    char: '🚛',
    fitzpatrick_scale: false,
    category: 'Most used',
  },
  tractor: {
    keywords: ['vehicle', 'car', 'farming', 'agriculture'],
    char: '🚜',
    fitzpatrick_scale: false,
    category: 'Most used',
  },
  motorcycle: {
    keywords: ['race', 'sports', 'fast'],
    char: '🏍',
    fitzpatrick_scale: false,
    category: 'Most used',
  },
  bike: {
    keywords: ['sports', 'bicycle', 'exercise', 'hipster'],
    char: '🚲',
    fitzpatrick_scale: false,
    category: 'Most used',
  },
  motor_scooter: {
    keywords: ['vehicle', 'vespa', 'sasha'],
    char: '🛵',
    fitzpatrick_scale: false,
    category: 'Most used',
  },
  oncoming_police_car: {
    keywords: ['vehicle', 'law', 'legal', 'enforcement', '911'],
    char: '🚔',
    fitzpatrick_scale: false,
    category: 'Most used',
  },
  oncoming_bus: {
    keywords: ['vehicle', 'transportation'],
    char: '🚍',
    fitzpatrick_scale: false,
    category: 'Most used',
  },
  oncoming_automobile: {
    keywords: ['car', 'vehicle', 'transportation'],
    char: '🚘',
    fitzpatrick_scale: false,
    category: 'Most used',
  },
  oncoming_taxi: {
    keywords: ['vehicle', 'cars', 'uber'],
    char: '🚖',
    fitzpatrick_scale: false,
    category: 'Most used',
  },
  railway_car: {
    keywords: ['transportation', 'vehicle'],
    char: '🚃',
    fitzpatrick_scale: false,
    category: 'Most used',
  },
  train: {
    keywords: ['transportation', 'vehicle', 'carriage', 'public', 'travel'],
    char: '🚋',
    fitzpatrick_scale: false,
    category: 'Most used',
  },
  monorail: {
    keywords: ['transportation', 'vehicle'],
    char: '🚝',
    fitzpatrick_scale: false,
    category: 'Most used',
  },
  bullettrain_side: {
    keywords: ['transportation', 'vehicle'],
    char: '🚄',
    fitzpatrick_scale: false,
    category: 'Most used',
  },
  bullettrain_front: {
    keywords: ['transportation', 'vehicle', 'speed', 'fast', 'public', 'travel'],
    char: '🚅',
    fitzpatrick_scale: false,
    category: 'Most used',
  },
  light_rail: {
    keywords: ['transportation', 'vehicle'],
    char: '🚈',
    fitzpatrick_scale: false,
    category: 'Most used',
  },
  mountain_railway: {
    keywords: ['transportation', 'vehicle'],
    char: '🚞',
    fitzpatrick_scale: false,
    category: 'Most used',
  },
  steam_locomotive: {
    keywords: ['transportation', 'vehicle', 'train'],
    char: '🚂',
    fitzpatrick_scale: false,
    category: 'Most used',
  },
  train2: {
    keywords: ['transportation', 'vehicle'],
    char: '🚆',
    fitzpatrick_scale: false,
    category: 'Most used',
  },
  metro: {
    keywords: ['transportation', 'blue-square', 'mrt', 'underground', 'tube'],
    char: '🚇',
    fitzpatrick_scale: false,
    category: 'Most used',
  },
  tram: {
    keywords: ['transportation', 'vehicle'],
    char: '🚊',
    fitzpatrick_scale: false,
    category: 'Most used',
  },
  station: {
    keywords: ['transportation', 'vehicle', 'public'],
    char: '🚉',
    fitzpatrick_scale: false,
    category: 'Most used',
  },
  helicopter: {
    keywords: ['transportation', 'vehicle', 'fly'],
    char: '🚁',
    fitzpatrick_scale: false,
    category: 'Most used',
  },
  small_airplane: {
    keywords: ['flight', 'transportation', 'fly', 'vehicle'],
    char: '🛩',
    fitzpatrick_scale: false,
    category: 'Most used',
  },
  airplane: {
    keywords: ['vehicle', 'transportation', 'flight', 'fly'],
    char: '✈️',
    fitzpatrick_scale: false,
    category: 'Most used',
  },
  flight_departure: {
    keywords: ['airport', 'flight', 'landing'],
    char: '🛫',
    fitzpatrick_scale: false,
    category: 'Most used',
  },
  flight_arrival: {
    keywords: ['airport', 'flight', 'boarding'],
    char: '🛬',
    fitzpatrick_scale: false,
    category: 'Most used',
  },
  motor_boat: { keywords: ['ship'], char: '🛥', fitzpatrick_scale: false, category: 'Most used' },
  speedboat: {
    keywords: ['ship', 'transportation', 'vehicle', 'summer'],
    char: '🚤',
    fitzpatrick_scale: false,
    category: 'Most used',
  },
  ferry: { keywords: ['boat', 'ship', 'yacht'], char: '⛴', fitzpatrick_scale: false, category: 'Most used' },
  passenger_ship: {
    keywords: ['yacht', 'cruise', 'ferry'],
    char: '🛳',
    fitzpatrick_scale: false,
    category: 'Most used',
  },
  passenger_ship_2: {
    keywords: ['yacht', 'cruise', 'ferry'],
    char: '🛳️',
    fitzpatrick_scale: false,
    category: 'Most used',
  },
  rocket: {
    keywords: ['launch', 'ship', 'staffmode', 'NASA', 'outer space', 'outer_space', 'fly'],
    char: '🚀',
    fitzpatrick_scale: false,
    category: 'Most used',
  },
  artificial_satellite: {
    keywords: ['communication', 'gps', 'orbit', 'spaceflight', 'NASA', 'ISS'],
    char: '🛰',
    fitzpatrick_scale: false,
    category: 'Most used',
  },
  ship: {
    keywords: ['transportation', 'titanic', 'deploy'],
    char: '🚢',
    fitzpatrick_scale: false,
    category: 'Most used',
  },
  img_truck: {
    keywords: ['truck'],
    char: '<img class="est-emoji" alt="truck" src="truck.png"/>',
    category: 'Most used',
  },
  img_truck_2: {
    keywords: ['truck'],
    char: '<img class="est-emoji" alt="truck 2" src="truck_2.png"/>',
    category: 'Most used',
  },
  img_truck_3: {
    keywords: ['truck'],
    char: '<img class="est-emoji" alt="truck 3" src="truck_3.png"/>',
    category: 'Most used',
  },
  img_truck_4: {
    keywords: ['truck'],
    char: '<img class="est-emoji" alt="truck 4" src="truck_4.png"/>',
    category: 'Most used',
  },
  img_truck_5: {
    keywords: ['truck'],
    char: '<img class="est-emoji" alt="truck 5" src="truck_5.png"/>',
    category: 'Most used',
  },
  img_truck_black: {
    keywords: ['truck', 'truck black'],
    char: '<img class="est-emoji" alt="truck black" src="truck_black.png"/>',
    category: 'Most used',
  },
  img_rocket: {
    keywords: ['rocket'],
    char: '<img class="est-emoji" alt="rocket" src="rocket.png"/>',
    category: 'Most used',
  },
  img_box: {
    keywords: ['box'],
    char: '<img class="est-emoji" alt="box" src="box.png"/>',
    category: 'Most used',
  },
  img_box_2: {
    keywords: ['box'],
    char: '<img class="est-emoji" alt="box 2" src="box_2.png"/>',
    category: 'Most used',
  },
  img_box_black: {
    keywords: ['box', 'box black'],
    char: '<img class="est-emoji" alt="box black" src="box_black.png"/>',
    category: 'Most used',
  },
  img_plane: {
    keywords: ['plane'],
    char: '<img class="est-emoji" alt="plane" src="plane.png"/>',
    category: 'Most used',
  },
  img_plane_black: {
    keywords: ['plane', 'plane black'],
    char: '<img class="est-emoji" alt="plane black" src="plane_black.png"/>',
    category: 'Most used',
  },
  img_bike: {
    keywords: ['bike'],
    char: '<img class="est-emoji" alt="bike" src="bike.png"/>',
    category: 'Most used',
  },
  img_motorbike: {
    keywords: ['motorbike'],
    char: '<img class="est-emoji" alt="motorbike" src="motobike.png"/>',
    category: 'Most used',
  },
  img_world_black: {
    keywords: ['world', 'world black'],
    char: '<img class="est-emoji" alt="world black" src="world_black.png"/>',
    category: 'Most used',
  },
  img_calendar_black: {
    keywords: ['calendar', 'calendar black'],
    char: '<img class="est-emoji" alt="calendar black" src="calendar_black.png"/>',
    category: 'Most used',
  },
  img_clock_black: {
    keywords: ['clock', 'clock black'],
    char: '<img class="est-emoji" alt="clock black" src="clock_black.png"/>',
    category: 'Most used',
  },
};

const img_url = 'https://media.synctrack.io/megamind-estimated/icon';

export const listEmoticons = [
  {
    keywords: ['red', 'transportation', 'vehicle'],
    char: '🚗',
  },
  {
    keywords: ['uber', 'vehicle', 'cars', 'transportation'],
    char: '🚕',
  },
  {
    keywords: ['transportation', 'vehicle'],
    char: '🚙',
  },
  {
    keywords: ['car', 'vehicle', 'transportation'],
    char: '🚌',
  },
  {
    keywords: ['bart', 'transportation', 'vehicle'],
    char: '🚎',
  },
  {
    keywords: ['sports', 'race', 'fast', 'formula', 'f1'],
    char: '🏎',
  },
  {
    keywords: ['vehicle', 'cars', 'transportation', 'law', 'legal', 'enforcement'],
    char: '🚓',
  },
  {
    keywords: ['health', '911', 'hospital'],
    char: '🚑',
  },
  {
    keywords: ['transportation', 'cars', 'vehicle'],
    char: '🚒',
  },
  {
    keywords: ['vehicle', 'car', 'transportation'],
    char: '🚐',
  },
  { keywords: ['cars', 'transportation'], char: '🚚' },
  {
    keywords: ['vehicle', 'cars', 'transportation', 'express'],
    char: '🚛',
  },
  {
    keywords: ['vehicle', 'car', 'farming', 'agriculture'],
    char: '🚜',
  },
  {
    keywords: ['race', 'sports', 'fast'],
    char: '🏍',
  },
  {
    keywords: ['sports', 'bicycle', 'exercise', 'hipster'],
    char: '🚲',
  },
  {
    keywords: ['vehicle', 'vespa', 'sasha'],
    char: '🛵',
  },
  {
    keywords: ['vehicle', 'law', 'legal', 'enforcement', '911'],
    char: '🚔',
  },
  {
    keywords: ['vehicle', 'transportation'],
    char: '🚍',
  },
  {
    keywords: ['car', 'vehicle', 'transportation'],
    char: '🚘',
  },
  {
    keywords: ['vehicle', 'cars', 'uber'],
    char: '🚖',
  },
  {
    keywords: ['transportation', 'vehicle'],
    char: '🚃',
  },
  {
    keywords: ['transportation', 'vehicle', 'carriage', 'public', 'travel'],
    char: '🚋',
  },
  {
    keywords: ['transportation', 'vehicle'],
    char: '🚝',
  },
  {
    keywords: ['transportation', 'vehicle'],
    char: '🚄',
  },
  {
    keywords: ['transportation', 'vehicle', 'speed', 'fast', 'public', 'travel'],
    char: '🚅',
  },
  {
    keywords: ['transportation', 'vehicle'],
    char: '🚈',
  },
  {
    keywords: ['transportation', 'vehicle'],
    char: '🚞',
  },
  {
    keywords: ['transportation', 'vehicle', 'train'],
    char: '🚂',
  },
  {
    keywords: ['transportation', 'vehicle'],
    char: '🚆',
  },
  {
    keywords: ['transportation', 'blue-square', 'mrt', 'underground', 'tube'],
    char: '🚇',
  },
  {
    keywords: ['transportation', 'vehicle'],
    char: '🚊',
  },
  {
    keywords: ['transportation', 'vehicle', 'public'],
    char: '🚉',
  },
  {
    keywords: ['transportation', 'vehicle', 'fly'],
    char: '🚁',
  },
  {
    keywords: ['flight', 'transportation', 'fly', 'vehicle'],
    char: '🛩',
  },
  {
    keywords: ['vehicle', 'transportation', 'flight', 'fly'],
    char: '✈️',
  },
  {
    keywords: ['airport', 'flight', 'landing'],
    char: '🛫',
  },
  {
    keywords: ['airport', 'flight', 'boarding'],
    char: '🛬',
  },
  { keywords: ['ship'], char: '🛥' },
  {
    keywords: ['ship', 'transportation', 'vehicle', 'summer'],
    char: '🚤',
  },
  { keywords: ['boat', 'ship', 'yacht'], char: '⛴' },
  {
    keywords: ['yacht', 'cruise', 'ferry'],
    char: '🛳',
  },
  {
    keywords: ['yacht', 'cruise', 'ferry'],
    char: '🛳️',
  },
  {
    keywords: ['launch', 'ship', 'staffmode', 'NASA', 'outer space', 'outer_space', 'fly'],
    char: '🚀',
  },
  {
    keywords: ['communication', 'gps', 'orbit', 'spaceflight', 'NASA', 'ISS'],
    char: '🛰',
  },
  {
    keywords: ['transportation', 'titanic', 'deploy'],
    char: '🚢',
  },
  {
    keywords: ['truck'],
    char: `<img class="est-emoji" alt="truck" src="${img_url}/truck.png"/>`,
    isImage: true,
  },
  {
    keywords: ['truck'],
    char: `<img class="est-emoji" alt="truck 2" src="${img_url}/truck_2.png"/>`,
    isImage: true,
  },
  {
    keywords: ['truck'],
    char: `<img class="est-emoji" alt="truck 3" src="${img_url}/truck_3.png"/>`,
    isImage: true,
  },
  {
    keywords: ['truck'],
    char: `<img class="est-emoji" alt="truck 4" src="${img_url}/truck_4.png"/>`,
    isImage: true,
  },
  {
    keywords: ['truck'],
    char: `<img class="est-emoji" alt="truck 5" src="${img_url}/truck_5.png"/>`,
    isImage: true,
  },
  {
    keywords: ['truck', 'truck black'],
    char: `<img class="est-emoji" alt="truck black" src="${img_url}/truck_black.png"/>`,
    isImage: true,
  },
  {
    keywords: ['rocket'],
    char: `<img class="est-emoji" alt="rocket" src="${img_url}/rocket.png"/>`,
    isImage: true,
  },
  {
    keywords: ['box'],
    char: `<img class="est-emoji" alt="box" src="${img_url}/box.png"/>`,
    isImage: true,
  },
  {
    keywords: ['box'],
    char: `<img class="est-emoji" alt="box 2" src="${img_url}/box_2.png"/>`,
    isImage: true,
  },
  {
    keywords: ['box', 'box black'],
    char: `<img class="est-emoji" alt="box black" src="${img_url}/box_black.png"/>`,
    isImage: true,
  },
  {
    keywords: ['plane'],
    char: `<img class="est-emoji" alt="plane" src="${img_url}/plane.png"/>`,
    isImage: true,
  },
  {
    keywords: ['plane', 'plane black'],
    char: `<img class="est-emoji" alt="plane black" src="${img_url}/plane_black.png"/>`,
    isImage: true,
  },
  {
    keywords: ['bike'],
    char: `<img class="est-emoji" alt="bike" src="${img_url}/bike.png"/>`,
    isImage: true,
  },
  {
    keywords: ['motorbike'],
    char: `<img class="est-emoji" alt="motorbike" src="${img_url}/motobike.png"/>`,
    isImage: true,
  },
  {
    keywords: ['world', 'world black'],
    char: `<img class="est-emoji" alt="world black" src="${img_url}/world_black.png"/>`,
    isImage: true,
  },
  {
    keywords: ['calendar', 'calendar black'],
    char: `<img class="est-emoji" alt="calendar black" src="${img_url}/calendar_black.png"/>`,
    isImage: true,
  },
  {
    keywords: ['clock', 'clock black'],
    char: `<img class="est-emoji" alt="clock black" src="${img_url}/clock_black.png"/>`,
    isImage: true,
  },
];

export const emojiIconList = [
  {
    id: 1,
    char: '🚚',
  },
  {
    id: 2,
    char: '🚛',
  },
  {
    id: 3,
    char: '🛻',
  },
  {
    id: 4,
    char: '✈️',
  },
  {
    id: 5,
    char: '🚢',
  },
  {
    id: 6,
    char: '🛒',
  },
  {
    id: 7,
    char: '🛍️',
  },
  {
    id: 8,
    char: '📦',
  },
  {
    id: 9,
    char: '⏰',
  },
  {
    id: 10,
    char: '⏳',
  },
  {
    id: 11,
    char: '🔥',
  },
  {
    id: 12,
    char: '⚡',
  },
  {
    id: 13,
    char: '✨',
  },
  {
    id: 14,
    char: '⭐',
  },
  {
    id: 15,
    char: '🏠',
  },
  {
    id: 16,
    char: '📍',
  },
  {
    id: 17,
    char: '✔️',
  },
  {
    id: 18,
    char: '☑️',
  },
  {
    id: 19,
    char: '✅',
  },
];

export const prefixIcons = [
  {
    id: PrefixIcon.none,
    icon: ({ size, color }: { size?: string; color?: string }) => 'none',
  },
  {
    id: PrefixIcon.truck,
    icon: ({ size, color }: { size?: string; color?: string }) => `<svg xmlns="http://www.w3.org/2000/svg" width=${
      size || '18'
    } height=${size || '18'} viewBox="0 0 18 18" fill="none">
<path d="M9.00005 5.39961V4.49961C9.00005 4.00255 8.5971 3.59961 8.10005 3.59961H2.70005C2.20299 3.59961 1.80005 4.00255 1.80005 4.49961V12.5996C1.80005 13.0967 2.20299 13.4996 2.70005 13.4996H3.85719M9.00005 5.39961H12.2273C12.466 5.39961 12.6949 5.49443 12.8637 5.66321L16.2 8.99961M9.00005 5.39961V8.99961M16.2 8.99961V12.5996C16.2 13.0967 15.7971 13.4996 15.3 13.4996H14.1429M16.2 8.99961H9.00005M9.00005 13.4996V8.99961M9.00005 13.4996H6.94291M9.00005 13.4996H11.0572M6.94291 13.4996C6.94291 14.3517 6.25215 15.0425 5.40005 15.0425C4.54795 15.0425 3.85719 14.3517 3.85719 13.4996M6.94291 13.4996C6.94291 12.6475 6.25215 11.9568 5.40005 11.9568C4.54795 11.9568 3.85719 12.6475 3.85719 13.4996M14.1429 13.4996C14.1429 14.3517 13.4521 15.0425 12.6 15.0425C11.748 15.0425 11.0572 14.3517 11.0572 13.4996M14.1429 13.4996C14.1429 12.6475 13.4521 11.9568 12.6 11.9568C11.748 11.9568 11.0572 12.6475 11.0572 13.4996" stroke=${
      color || '#707070'
    } strokeWidth="1.4"/>
</svg>`,
  },
  {
    id: PrefixIcon.delivered,
    icon: ({ size, color }: { size?: string; color?: string }) => `<svg xmlns="http://www.w3.org/2000/svg" width=${
      size || '18'
    } height=${size || '18'} viewBox="0 0 18 18" fill="none">
<path d="M14.4 10.8008V15.3008C14.4 15.7978 13.9971 16.2008 13.5 16.2008H10.8M14.4 10.8008L9.63644 6.03718C9.28497 5.68571 8.71512 5.68571 8.36365 6.03718L3.60005 10.8008M14.4 10.8008L15.5637 9.63718C15.9151 9.2857 15.9151 8.71586 15.5637 8.36439L9.63644 2.43718C9.28497 2.08571 8.71512 2.0857 8.36365 2.43718L2.43644 8.36438C2.08497 8.71586 2.08497 9.2857 2.43644 9.63718L3.60005 10.8008M3.60005 10.8008V15.3008C3.60005 15.7978 4.00299 16.2008 4.50005 16.2008H7.20005M7.20005 16.2008V12.6008C7.20005 12.1037 7.60299 11.7008 8.10005 11.7008H9.90005C10.3971 11.7008 10.8 12.1037 10.8 12.6008V16.2008M7.20005 16.2008H10.8" stroke=${
      color || '#707070'
    } strokeWidth="1.4" strokeLinecap="round" strokeLinejoin="round"/>
</svg>`,
  },
  {
    id: PrefixIcon.store,
    icon: ({ size, color }: { size?: string; color?: string }) => `<svg xmlns="http://www.w3.org/2000/svg" width=${
      size || '18'
    } height=${size || '18'} viewBox="0 0 18 18" fill="none">
<path d="M1.79989 5.40078L4.3186 2.0425C4.43272 1.89033 4.61183 1.80078 4.80203 1.80078H13.1977C13.3879 1.80078 13.5671 1.89033 13.6812 2.0425L16.1999 5.40078M1.79989 5.40078H16.1999M1.79989 5.40078C1.79989 5.40078 1.02846 9.00078 3.59989 8.9863M16.1999 5.40078C16.1999 5.40078 16.9713 9.00078 14.3999 8.9863M3.59989 8.9863C6.17132 9.00078 6.42846 5.40078 6.42846 5.40078C6.42846 5.40078 6.42846 9.00078 8.99989 9.00078C11.5713 9.00078 11.5713 5.40078 11.5713 5.40078C11.5713 5.40078 11.8285 9.00078 14.3999 8.9863M3.59989 8.9863V15.5965C3.59989 15.9302 3.87044 16.2008 4.20417 16.2008H7.19989M14.3999 8.9863V15.5965C14.3999 15.9302 14.1293 16.2008 13.7956 16.2008H10.6713M7.19989 16.2008V12.3051C7.19989 11.9713 7.47044 11.7008 7.80417 11.7008H10.067C10.4008 11.7008 10.6713 11.9713 10.6713 12.3051V16.2008M7.19989 16.2008H10.6713" stroke=${
      color || '#707070'
    } strokeWidth="1.4" strokeLinecap="round"/>
</svg>`,
  },
  {
    id: PrefixIcon.calendar,
    icon: ({ size, color }: { size?: string; color?: string }) => `<svg xmlns="http://www.w3.org/2000/svg" width=${
      size || '18'
    } height=${size || '18'} viewBox="0 0 18 18" fill="none">
<path d="M5.40005 3.60078H2.70005C2.20299 3.60078 1.80005 4.00372 1.80005 4.50078V7.20078M5.40005 3.60078H12.6M5.40005 3.60078V1.80078M12.6 3.60078H15.3C15.7971 3.60078 16.2 4.00373 16.2 4.50078V7.20078M12.6 3.60078V1.80078M1.80005 7.20078V15.3008C1.80005 15.7978 2.20299 16.2008 2.70005 16.2008H6.56195H11.4381H15.3C15.7971 16.2008 16.2 15.7978 16.2 15.3008V7.20078M1.80005 7.20078H9.00005H16.2M5.01433 10.1579H5.78576M8.61433 10.1579H9.38576M12.2143 10.1579H12.9858M5.01433 13.2436H5.78576M8.61433 13.2436H9.38576M12.2143 13.2436H12.9858" stroke=${
      color || '#707070'
    } strokeWidth="1.4" strokeLinecap="round"/>
</svg>`,
  },
  {
    id: PrefixIcon.clock,
    icon: ({ size, color }: { size?: string; color?: string }) => `<svg xmlns="http://www.w3.org/2000/svg" width=${
      size || '18'
    } height=${size || '18'} viewBox="0 0 18 18" fill="none">
<path d="M9.00002 5.40084V8.81445C9.00002 8.9338 9.04743 9.04826 9.13182 9.13265L10.9286 10.9294M16.2 9.00078C16.2 12.9772 12.9765 16.2008 9.00005 16.2008C5.0236 16.2008 1.80005 12.9772 1.80005 9.00078C1.80005 5.02433 5.0236 1.80078 9.00005 1.80078C12.9765 1.80078 16.2 5.02433 16.2 9.00078Z" stroke=${
      color || '#707070'
    } strokeWidth="1.4" strokeLinecap="round" strokeLinejoin="round"/>
</svg>`,
  },
  {
    id: PrefixIcon.bag,
    icon: ({ size, color }: { size?: string; color?: string }) => `<svg xmlns="http://www.w3.org/2000/svg" width=${
      size || '18'
    } height=${size || '18'} viewBox="0 0 18 18" fill="none">
<path d="M3.43867 12.9054L3.94973 5.40078H14.0502L14.5613 12.9054C14.6827 14.688 13.2694 16.2008 11.4827 16.2008H6.51726C4.73054 16.2008 3.31728 14.688 3.43867 12.9054Z" stroke=${
      color || '#707070'
    } strokeWidth="1.4"/>
<path d="M6.29997 4.50078C6.29997 3.00961 7.50881 1.80078 8.99997 1.80078C10.4911 1.80078 11.7 3.00961 11.7 4.50078V6.30078C11.7 7.79195 10.4911 9.00078 8.99997 9.00078C7.50881 9.00078 6.29997 7.79195 6.29997 6.30078V4.50078Z" stroke=${
      color || '#707070'
    } strokeWidth="1.4"/>
</svg>`,
  },
  {
    id: PrefixIcon.cart,
    icon: ({ size, color }: { size?: string; color?: string }) => `<svg xmlns="http://www.w3.org/2000/svg" width=${
      size || '18'
    } height=${size || '18'} viewBox="0 0 18 18" fill="none">
  <path d="M1.80005 2.69922H2.91263C3.31849 2.69922 3.67413 2.97086 3.78092 3.36241L6.11918 11.936C6.22597 12.3276 6.58161 12.5992 6.98746 12.5992H13.6973C14.1103 12.5992 14.4703 12.3182 14.5705 11.9175L15.9205 6.5175C16.0625 5.94947 15.6329 5.39922 15.0474 5.39922H4.37148M4.88576 15.2992C4.88576 15.5122 4.71307 15.6849 4.50005 15.6849C4.28702 15.6849 4.11433 15.5122 4.11433 15.2992C4.11433 15.0862 4.28702 14.9135 4.50005 14.9135C4.71307 14.9135 4.88576 15.0862 4.88576 15.2992ZM13.8858 15.2992C13.8858 15.5122 13.7131 15.6849 13.5 15.6849C13.287 15.6849 13.1143 15.5122 13.1143 15.2992C13.1143 15.0862 13.287 14.9135 13.5 14.9135C13.7131 14.9135 13.8858 15.0862 13.8858 15.2992ZM4.49684 15.296H4.50284V15.3024H4.49684V15.296ZM13.4968 15.296H13.5028V15.3024H13.4968V15.296Z" stroke=${
    color || '#707070'
  } strokeWidth="1.4" strokeLinecap="round" strokeLinejoin="round"/>
</svg>`,
  },
  {
    id: PrefixIcon.delivery,
    icon: ({ size, color }: { size?: string; color?: string }) => `<svg xmlns="http://www.w3.org/2000/svg" width=${
      size || '18'
    } height=${size || '18'} viewBox="0 0 18 18" fill="none">
  <path d="M10.3696 13.7302C10.8234 14.5162 10.5541 15.5213 9.76804 15.9751C8.98202 16.4289 7.97695 16.1596 7.52314 15.3736C7.06933 14.5875 7.33864 13.5825 8.12466 13.1287M10.3696 13.7302C9.91575 12.9442 8.91067 12.6749 8.12466 13.1287M10.3696 13.7302L15.1136 10.9912M8.12466 13.1287L5.65959 8.85904M2.64673 3.64061L4.01621 6.01263M16.0624 10.4434L15.1136 10.9912M5.65959 8.85904L10.4036 6.12008M5.65959 8.85904L4.01621 6.01263M15.1136 10.9912L12.0454 5.67696C11.9247 5.46788 11.6573 5.39625 11.4482 5.51696L10.4036 6.12008M10.4036 6.12008L8.97881 3.65224C8.85809 3.44316 8.59074 3.37152 8.38166 3.49223L4.01621 6.01263" stroke=${
    color || '#707070'
  } strokeWidth="1.4" strokeLinecap="round" strokeLinejoin="round"/>
</svg>`,
  },
  {
    id: PrefixIcon.gift,
    icon: ({ size, color }: { size?: string; color?: string }) => `<svg xmlns="http://www.w3.org/2000/svg" width=${
      size || '18'
    } height=${size || '18'} viewBox="0 0 18 18" fill="none">
  <path d="M2.70005 9.00078V15.5965C2.70005 15.9302 2.9706 16.2008 3.30433 16.2008H9.00005M2.70005 9.00078H2.40433C2.0706 9.00078 1.80005 8.73023 1.80005 8.39649V6.00507C1.80005 5.67133 2.0706 5.40078 2.40433 5.40078H4.3165M2.70005 9.00078H9.00005M15.3 9.00078V15.5965C15.3 15.9302 15.0295 16.2008 14.6958 16.2008H9.00005M15.3 9.00078H15.5958C15.9295 9.00078 16.2 8.73023 16.2 8.3965V6.00507C16.2 5.67133 15.9295 5.40078 15.5958 5.40078H13.555M15.3 9.00078H9.00005M9.00005 9.00078V16.2008M9.00005 5.40078H4.3165M9.00005 5.40078C9.00005 5.40078 8.64479 1.80078 5.73501 1.80078C2.82524 1.80078 4.3165 5.40078 4.3165 5.40078M9.00005 5.40078H13.555M9.00005 5.40078C9.00005 5.40078 9.22674 1.80078 12.1365 1.80078C15.0463 1.80078 13.555 5.40078 13.555 5.40078" stroke=${
    color || '#707070'
  } strokeWidth="1.4" strokeLinecap="round"/>
</svg>`,
  },
  {
    id: PrefixIcon.marker,
    icon: ({ size, color }: { size?: string; color?: string }) => `<svg xmlns="http://www.w3.org/2000/svg" width=${
      size || '18'
    } height=${size || '18'} viewBox="0 0 18 18" fill="none">
  <path d="M9.40351 15.7974L9.90554 16.2852L9.40351 15.7974ZM8.59638 15.7974L9.09841 15.3096L8.59638 15.7974ZM8.99673 7.19756V6.49756C8.61013 6.49756 8.29673 6.81096 8.29673 7.19756H8.99673ZM9.00273 7.19756H9.70273C9.70273 6.81096 9.38933 6.49756 9.00273 6.49756V7.19756ZM9.00273 7.20399V7.90399C9.38933 7.90399 9.70273 7.59059 9.70273 7.20399H9.00273ZM8.99673 7.20399H8.29673C8.29673 7.59059 8.61013 7.90399 8.99673 7.90399V7.20399ZM13.5714 7.13573C13.5714 8.60085 12.7648 10.3018 11.7183 11.8634C10.6886 13.4 9.5038 14.6897 8.90148 15.3096L9.90554 16.2852C10.5363 15.636 11.7854 14.2781 12.8814 12.6428C13.9605 11.0324 14.9714 9.03704 14.9714 7.13573H13.5714ZM9.09841 15.3096C8.49609 14.6897 7.31127 13.4 6.28154 11.8634C5.23505 10.3018 4.42852 8.60085 4.42852 7.13573H3.02852C3.02852 9.03704 4.03936 11.0324 5.11854 12.6428C6.21446 14.2781 7.46358 15.636 8.09435 16.2852L9.09841 15.3096ZM4.42852 7.13573C4.42852 4.56799 6.48309 2.50078 8.99994 2.50078V1.10078C5.69413 1.10078 3.02852 3.81065 3.02852 7.13573H4.42852ZM8.99994 2.50078C11.5168 2.50078 13.5714 4.56799 13.5714 7.13573H14.9714C14.9714 3.81065 12.3058 1.10078 8.99994 1.10078V2.50078ZM8.90148 15.3096C8.92258 15.2878 8.9586 15.2705 8.99994 15.2705C9.04129 15.2705 9.0773 15.2878 9.09841 15.3096L8.09435 16.2852C8.59354 16.7989 9.40635 16.7989 9.90554 16.2852L8.90148 15.3096ZM9.19994 7.20078C9.19994 7.31124 9.1104 7.40078 8.99994 7.40078V8.80078C9.8836 8.80078 10.5999 8.08444 10.5999 7.20078H9.19994ZM8.99994 7.40078C8.88949 7.40078 8.79994 7.31124 8.79994 7.20078H7.39994C7.39994 8.08444 8.11629 8.80078 8.99994 8.80078V7.40078ZM8.79994 7.20078C8.79994 7.09032 8.88949 7.00078 8.99994 7.00078V5.60078C8.11629 5.60078 7.39994 6.31713 7.39994 7.20078H8.79994ZM8.99994 7.00078C9.1104 7.00078 9.19994 7.09032 9.19994 7.20078H10.5999C10.5999 6.31713 9.8836 5.60078 8.99994 5.60078V7.00078ZM8.99673 7.89756H9.00273V6.49756H8.99673V7.89756ZM8.30273 7.19756V7.20399H9.70273V7.19756H8.30273ZM9.00273 6.50399H8.99673V7.90399H9.00273V6.50399ZM9.69673 7.20399V7.19756H8.29673V7.20399H9.69673Z" fill="#707070"/>
</svg>`,
  },
  {
    id: PrefixIcon.geolocation,
    icon: ({ size, color }: { size?: string; color?: string }) => `<svg xmlns="http://www.w3.org/2000/svg" width=${
      size || '18'
    } height=${size || '18'} viewBox="0 0 18 18" fill="none">
  <path d="M9.24513 15.674L15.1505 3.01962C15.2013 2.91081 15.0885 2.79796 14.9796 2.84874L2.32522 8.75414C2.20056 8.81231 2.24203 8.99922 2.37959 8.99922H8.55005C8.79858 8.99922 9.00005 9.20069 9.00005 9.44922V15.6197C9.00005 15.7572 9.18696 15.7987 9.24513 15.674Z" stroke=${
    color || '#707070'
  } strokeWidth="1.4" strokeLinejoin="round"/>
</svg>`,
  },
  {
    id: PrefixIcon.info,
    icon: ({ size, color }: { size?: string; color?: string }) => `<svg xmlns="http://www.w3.org/2000/svg" width=${
      size || '18'
    } height=${size || '18'} viewBox="0 0 18 18" fill="none">
  <path d="M9.00005 13.0008V9.12935C9.00005 9.05834 8.94249 9.00078 8.87148 9.00078H8.00005M16.2 9.00078C16.2 12.9772 12.9765 16.2008 9.00005 16.2008C5.0236 16.2008 1.80005 12.9772 1.80005 9.00078C1.80005 5.02433 5.0236 1.80078 9.00005 1.80078C12.9765 1.80078 16.2 5.02433 16.2 9.00078ZM9.51433 5.40078C9.51433 5.68481 9.28408 5.91507 9.00005 5.91507C8.71602 5.91507 8.48576 5.68481 8.48576 5.40078C8.48576 5.11675 8.71602 4.8865 9.00005 4.8865C9.28408 4.8865 9.51433 5.11675 9.51433 5.40078ZM8.99683 5.39757H9.00284V5.404H8.99683V5.39757Z" stroke=${
    color || '#707070'
  } strokeWidth="1.4" strokeLinecap="round" strokeLinejoin="round"/>
</svg>`,
  },
  {
    id: PrefixIcon.critical,
    icon: ({ size, color }: { size?: string; color?: string }) => `<svg xmlns="http://www.w3.org/2000/svg" width=${
      size || '18'
    } height=${size || '18'} viewBox="0 0 18 18" fill="none">
  <path d="M9.00005 5.25078L9.00005 8.75078M16.2 9.00078C16.2 12.9772 12.9765 16.2008 9.00005 16.2008C5.0236 16.2008 1.80005 12.9772 1.80005 9.00078C1.80005 5.02433 5.0236 1.80078 9.00005 1.80078C12.9765 1.80078 16.2 5.02433 16.2 9.00078ZM9.25719 12.6008C9.25719 12.7428 9.14206 12.8579 9.00005 12.8579C8.85803 12.8579 8.74291 12.7428 8.74291 12.6008C8.74291 12.4588 8.85803 12.3436 9.00005 12.3436C9.14206 12.3436 9.25719 12.4588 9.25719 12.6008ZM8.99683 12.5976H9.00284V12.604H8.99683V12.5976Z" stroke=${
    color || '#707070'
  } strokeWidth="1.4" strokeLinecap="round" strokeLinejoin="round"/>
</svg>`,
  },
  {
    id: PrefixIcon.warning,
    icon: ({ size, color }: { size?: string; color?: string }) => `<svg xmlns="http://www.w3.org/2000/svg" width=${
      size || '18'
    } height=${size || '18'} viewBox="0 0 18 18" fill="none">
  <path d="M9 7.19922L9 9.89922" stroke=${color || '#707070'} strokeWidth="1.4" strokeLinecap="round"/>
  <circle cx="9.00006" cy="12.6009" r="0.257143" stroke=${color || '#707070'} strokeWidth="1.4"/>
  <path d="M9.00283 12.5977H8.99683V12.6041H9.00283V12.5977Z" stroke=${
    color || '#707070'
  } strokeWidth="1.4" strokeLinecap="round" strokeLinejoin="round"/>
  <path d="M8.46685 2.80052C8.69435 2.37396 9.30575 2.37396 9.53324 2.80052L15.7261 14.4121C15.9408 14.8146 15.6491 15.3008 15.1929 15.3008H2.80719C2.351 15.3008 2.05932 14.8146 2.274 14.4121L8.46685 2.80052Z" stroke=${
    color || '#707070'
  } strokeWidth="1.4"/>
</svg>`,
  },
  {
    id: PrefixIcon.success,
    icon: ({ size, color }: { size?: string; color?: string }) => `<svg xmlns="http://www.w3.org/2000/svg" width=${
      size || '18'
    } height=${size || '18'} viewBox="0 0 18 18" fill="none">
  <path d="M12.2143 6.6865L8.88918 11.6909C8.7092 11.9617 8.32614 11.9996 8.09657 11.7693L5.78576 9.45078M16.2 9.00078C16.2 12.9772 12.9765 16.2008 9.00005 16.2008C5.0236 16.2008 1.80005 12.9772 1.80005 9.00078C1.80005 5.02433 5.0236 1.80078 9.00005 1.80078C12.9765 1.80078 16.2 5.02433 16.2 9.00078Z" stroke=${
    color || '#707070'
  } strokeWidth="1.4" strokeLinecap="round" strokeLinejoin="round"/>
</svg>`,
  },
  {
    id: PrefixIcon.checkmark,
    icon: ({ size, color }: { size?: string; color?: string }) => `<svg xmlns="http://www.w3.org/2000/svg" width=${
      size || '18'
    } height=${size || '18'} viewBox="0 0 18 18" fill="none">
  <path d="M15.5572 3.59961L8.00072 14.9696C7.84324 15.2066 7.50812 15.2398 7.30725 15.0383L1.80005 9.5139" stroke=${
    color || '#707070'
  } strokeWidth="1.4" strokeLinecap="round" strokeLinejoin="round"/>
</svg>`,
  },
];
